// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"TableRow_tableRow__lb9bo"};